import React, { useState } from "react";
import SEO from "./components/SEO";
import "./VideoManager.css";
import RecordingStudio from "./components/videoManager/RecordingStudio";
import VideoEditingStudio from "./components/videoManager/VideoEditingStudio";
import AudioEditingStudio from "./components/videoManager/AudioEditingStudio";
import TranscriptionTool from "./components/videoManager/TranscriptionTool";
import AdvancedVideoEditor from "./components/videoManager/AdvancedVideoEditor";
import AdvancedAudioEditor from "./components/videoManager/AdvancedAudioEditor";
import ImageEditingStudio from "./components/videoManager/ImageEditingStudio";
import {
  FaFilm,
  FaWaveSquare,
  FaImage,
  FaRecordVinyl,
  FaPlayCircle,
  FaHeadphones,
  FaClipboardList,
} from "react-icons/fa";

const FEATURE_TABS = [
  {
    id: "advanced-video",
    label: "Video Edit",
    Component: AdvancedVideoEditor,
    Icon: FaFilm,
  },
  {
    id: "advanced-audio",
    label: "Audio Studio",
    Component: AdvancedAudioEditor,
    Icon: FaWaveSquare,
  },
  {
    id: "image",
    label: "Image Edit",
    Component: ImageEditingStudio,
    Icon: FaImage,
  },
  {
    id: "record",
    label: "Screen Record",
    Component: RecordingStudio,
    Icon: FaRecordVinyl,
  },
  {
    id: "video",
    label: "Video Karaoke",
    Component: VideoEditingStudio,
    Icon: FaPlayCircle,
  },
  {
    id: "audio",
    label: "Audio Lab",
    Component: AudioEditingStudio,
    Icon: FaHeadphones,
  },
  {
    id: "transcript",
    label: "Transcribe",
    Component: TranscriptionTool,
    Icon: FaClipboardList,
  },
];

const FEATURE_PANEL_CLASSES = {
  "advanced-video": "video-panel video-panel--editor",
  "advanced-audio": "video-panel video-panel--audio",
  image: "video-panel video-panel--editor",
  record: "video-panel video-panel--record",
  video: "video-panel video-panel--editor",
  audio: "video-panel video-panel--audio",
  transcript: "video-panel video-panel--transcript",
};

export default function VideoManager() {
  const [activeTab, setActiveTab] = useState(FEATURE_TABS[0].id);

  return (
    <main className="video-manager">
      <SEO
        title="Media Tools"
        description="Edit and manage video, audio, and images."
      />
      <div className="video-manager__tabs-shell">
        <nav className="video-manager__tabs" aria-label="Media tools sections">
          {FEATURE_TABS.map((feature) => (
            <button
              key={feature.id}
              type="button"
              className={`video-manager__tab${activeTab === feature.id ? " active" : ""}`}
              onClick={() => setActiveTab(feature.id)}
            >
              {feature.Icon && <feature.Icon className="video-manager__tab-icon" aria-hidden="true" />}
              <span className="video-manager__tab-label">{feature.label}</span>
            </button>
          ))}
        </nav>
      </div>

      <section className="video-manager__feature-shell">
        {FEATURE_TABS.map((feature) => {
          const PanelComponent = feature.Component;
          return (
            <div
              key={feature.id}
              className={`${FEATURE_PANEL_CLASSES[feature.id]} video-manager__feature-panel${
                activeTab === feature.id ? " active" : ""
              }`}
              aria-hidden={activeTab !== feature.id}
            >
              <PanelComponent />
            </div>
          );
        })}
      </section>
    </main>
  );
}
